<small class="debug">{{me}}</small>
<div class="playlist_properties">
  <app-video-link style="position: fixed; top: -10px; width: 50px; height: 50px" videoLink="/help/YouTube"></app-video-link>
  <div class="clearFloat"></div>
  <div style="border: black 2px dashed; width: 270px; height: 80px; margin-right: 8px">
    <!--        <mat-label>{{'general.allSitesExtension' | transloco}}</mat-label>-->
    <br/>
    <mat-label>Bind events and scenes to take actions upon user interaction</mat-label>
    <br/>
  </div>
  <div class="playlist_properties">
    @if (dynamicsInitialized) {
      <div>
        <dynamic-form
          [fields]="uiConfigInit"
          [ignoreValidation]="true"
          (submit)="submit($event)">
        </dynamic-form>
      </div>
    }
  </div>
</div>
